import {
  E_WAY_BILL_TABLE,
  E_WAY_BILL_AUTH_TOKEN,
  E_WAY_BILL_INVOICE_DATA,
  E_WAY_BILL_CREATE,
  E_WAY_BILL_VIEW,
  E_WAY_BILL_MASTERS,
  E_WAY_BILL_UPDATE_TRANSPORTER,
  E_WAY_BILL_CANCEL,
  E_WAY_BILL_REJECT,
  E_INVOICE_TABLE,
  E_INVOICE_GENERATE,
  E_INVOICE_AUTH_TOKEN,
  E_INVOICE_INVOICE_DATA,
  GL_ACC_LIST,
  PAYMENT_IN_CREATE,
  PAYMENT_IN_EDIT,
  PAYMENT_IN_TABLE,
  PAYMENT_IN_VIEW,
  SALES_CREATE,
  SALES_CREDIT_EDIT,
  SALES_CREDIT_RECEIPT_CREATE,
  SALES_CREDIT_TABLE,
  SALES_CREDIT_VIEW,
  SALES_CREDIT_VOID,
  SALES_DELIVERY_EDIT,
  SALES_DELIVERY_ITEMS_GET,
  SALES_DELIVERY_RECEIPT_CREATE,
  SALES_DELIVERY_TABLE,
  SALES_DELIVERY_VIEW,
  SALES_DELIVERY_VOID,
  SALES_EDIT,
  SALES_INVOICE_EDIT,
  SALES_INVOICE_ITEMS_GET,
  SALES_INVOICE_RECEIPT_CREATE,
  SALES_INVOICE_TABLE,
  SALES_INVOICE_VIEW,
  SALES_INVOICE_VOID,
  SALES_ORDER_ITEMS_GET,
  SALES_PAYMENT_IN_CUS,
  SALES_PRODUCT_DETAILS,
  SALES_PRODUCT_LIST,
  SALES_RETURN_EDIT,
  SALES_RETURN_ITEMS_GET,
  SALES_RETURN_RECEIPT_CREATE,
  SALES_RETURN_TABLE,
  SALES_RETURN_VIEW,
  SALES_RETURN_VOID,
  SALES_TABLE,
  SALES_TAX_CAL,
  SALES_VIEW,
  SALES_VOID,
  CREATE_PICKLIST,
  VIEW_PICKLIST,
  UPDATE_PICKLIST,
  PICKLIST_TABLE,
  PICKLIST_DASHBOARD,
  PICKLIST_ITEMS_GET,
  PICKLIST_VIEW_ITEMS,
  BACKEND_CONFIG_GET,
  BACKEND_CONFIG_RESET,
  VOID_PICKLIST
} from "../types";

export const salesCreateAction = (data, onSuccess, onError) => {
  return {
    type: SALES_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const salesEditAction = (data, onSuccess, onError) => {
  return {
    type: SALES_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const salesTableAction = (data, onSuccess, onError) => {
  return {
    type: SALES_TABLE,
    data,
    onSuccess,
    onError,
  };
};
export const salesProductListAction = (data, onSuccess, onError) => {
  return {
    type: SALES_PRODUCT_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const salesOrderItemsGetAction = (data, onSuccess, onError) => {
  return {
    type: SALES_ORDER_ITEMS_GET,
    data,
    onSuccess,
    onError,
  };
};
export const salesViewAction = (data, onSuccess, onError) => {
  return {
    type: SALES_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const salesVoidAction = (data, onSuccess, onError) => {
  return {
    type: SALES_VOID,
    data,
    onSuccess,
    onError,
  };
};

export const salesDeliveryReceiptCreateAction = (data, onSuccess, onError) => {
  return {
    type: SALES_DELIVERY_RECEIPT_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const salesDeliveryTableAction = (data, onSuccess, onError) => {
  return {
    type: SALES_DELIVERY_TABLE,
    data,
    onSuccess,
    onError,
  };
};
export const salesDeliveryViewAction = (data, onSuccess, onError) => {
  return {
    type: SALES_DELIVERY_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const salesDeliveryEditAction = (data, onSuccess, onError) => {
  return {
    type: SALES_DELIVERY_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const salesDeliveryVoidAction = (data, onSuccess, onError) => {
  return {
    type: SALES_DELIVERY_VOID,
    data,
    onSuccess,
    onError,
  };
};
export const salesDeliveryItemsGetAction = (data, onSuccess, onError) => {
  return {
    type: SALES_DELIVERY_ITEMS_GET,
    data,
    onSuccess,
    onError,
  };
};
export const CreatePickList = (data, onSuccess, onError) => {
  return {
    type: CREATE_PICKLIST,
    data,
    onSuccess,
    onError,
  };
};
export const ViewPickList = (data, onSuccess, onError) => {
  return {
    type: VIEW_PICKLIST,
    data,
    onSuccess,
    onError,
  };
};
export const viewPickListItemsAction = (data, onSuccess, onError) => {
  return {
    type: PICKLIST_VIEW_ITEMS,
    data,
    onSuccess,
    onError,
  };
};
export const UpdatePickList = (data, onSuccess, onError) => {
  return {
    type: UPDATE_PICKLIST,
    data,
    onSuccess,
    onError,
  };
};
export const PickListTableAction = (data, onSuccess, onError) => {
  return {
    type: PICKLIST_TABLE,
    data,
    onSuccess,
    onError,
  };
};
export const PickListDashboardAction = (data, onSuccess, onError) => {
  return {
    type: PICKLIST_DASHBOARD,
    data,
    onSuccess,
    onError,
  };
};
export const pickListItemsGetAction = (data, onSuccess, onError) => {
  return {
    type: PICKLIST_ITEMS_GET,
    data,
    onSuccess,
    onError,
  };
};
export const backendConfigGetAction = (onSuccess, onError) => {
  return {
    type: BACKEND_CONFIG_GET,
    onSuccess,
    onError,
  };
};
export const backendConfigResetAction = () => {
  return {
    type: BACKEND_CONFIG_RESET,
  };
};
export const VoidPickList = (data, onSuccess, onError) => {
  return {
    type: VOID_PICKLIST,
    data,
    onSuccess,
    onError,
  };
};
export const salesInvoiceReceiptCreateAction = (data, onSuccess, onError) => {
  return {
    type: SALES_INVOICE_RECEIPT_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const salesInvoiceTableAction = (data, onSuccess, onError) => {
  return {
    type: SALES_INVOICE_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const salesInvoiceViewAction = (data, onSuccess, onError) => {
  return {
    type: SALES_INVOICE_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const salesInvoiceVoidAction = (data, onSuccess, onError) => {
  return {
    type: SALES_INVOICE_VOID,
    data,
    onSuccess,
    onError,
  };
};
export const salesInvoiceEditAction = (data, onSuccess, onError) => {
  return {
    type: SALES_INVOICE_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const salesInvoiceItemsGetAction = (data, onSuccess, onError) => {
  return {
    type: SALES_INVOICE_ITEMS_GET,
    data,
    onSuccess,
    onError,
  };
};

export const salesReturnReceiptCreateAction = (data, onSuccess, onError) => {
  return {
    type: SALES_RETURN_RECEIPT_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const salesReturnTableAction = (data, onSuccess, onError) => {
  return {
    type: SALES_RETURN_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const salesReturnViewAction = (data, onSuccess, onError) => {
  return {
    type: SALES_RETURN_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const salesReturnEditAction = (data, onSuccess, onError) => {
  return {
    type: SALES_RETURN_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const salesReturnVoidAction = (data, onSuccess, onError) => {
  return {
    type: SALES_RETURN_VOID,
    data,
    onSuccess,
    onError,
  };
};
export const salesReturnItemsGetAction = (data, onSuccess, onError) => {
  return {
    type: SALES_RETURN_ITEMS_GET,
    data,
    onSuccess,
    onError,
  };
};

export const salesCreditReceiptCreateAction = (data, onSuccess, onError) => {
  return {
    type: SALES_CREDIT_RECEIPT_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const salesCreditTableAction = (data, onSuccess, onError) => {
  return {
    type: SALES_CREDIT_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const salesCreditViewAction = (data, onSuccess, onError) => {
  return {
    type: SALES_CREDIT_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const salesCreditEditAction = (data, onSuccess, onError) => {
  return {
    type: SALES_CREDIT_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const salesCreditVoidAction = (data, onSuccess, onError) => {
  return {
    type: SALES_CREDIT_VOID,
    data,
    onSuccess,
    onError,
  };
};
export const salesPaymentInCusAction = (data, onSuccess, onError) => {
  return {
    type: SALES_PAYMENT_IN_CUS,
    data,
    onSuccess,
    onError,
  };
};

export const paymentInTableAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_IN_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const glAccListAction = (onSuccess, onError) => {
  return {
    type: GL_ACC_LIST,
    onSuccess,
    onError,
  };
};

export const paymentInCreateAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_IN_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const paymentInEditAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_IN_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const paymentInViewAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_IN_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const salesProductDetailsAction = (data, onSuccess, onError) => {
  return {
    type: SALES_PRODUCT_DETAILS,
    data,
    onSuccess,
    onError,
  };
};

export const salesTaxCalAction = (data, onSuccess, onError) => {
  return {
    type: SALES_TAX_CAL,
    data,
    onSuccess,
    onError,
  };
};

export const eWayBillTableAction = (data, onSuccess, onError) => {
  return {
    type: E_WAY_BILL_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const eWayBillAuthTokenAction = (onSuccess, onError) => {
  return {
    type: E_WAY_BILL_AUTH_TOKEN,
    onSuccess,
    onError,
  };
};

export const eWayBillInvoiceDataAction = (data, onSuccess, onError) => {
  return {
    type: E_WAY_BILL_INVOICE_DATA,
    data,
    onSuccess,
    onError,
  };
};

export const eWayBillViewAction = (data, onSuccess, onError) => {
  return { type: E_WAY_BILL_VIEW, data, onSuccess, onError };
};

export const eWayBillMastersAction = (onSuccess, onError) => {
  return { type: E_WAY_BILL_MASTERS, onSuccess, onError };
};

export const eWayBillCreateAction = (data, onSuccess, onError) => {
  return {
    type: E_WAY_BILL_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const eWayBillUpdateTransporterAction = (data, onSuccess, onError) => {
  return { type: E_WAY_BILL_UPDATE_TRANSPORTER, data, onSuccess, onError };
};

export const eWayBillCancelAction = (data, onSuccess, onError) => {
  return { type: E_WAY_BILL_CANCEL, data, onSuccess, onError };
};

export const eWayBillRejectAction = (data, onSuccess, onError) => {
  return { type: E_WAY_BILL_REJECT, data, onSuccess, onError };
};

export const eInvoiceAuthTokenAction = (onSuccess, onError) => {
  return { type: E_INVOICE_AUTH_TOKEN, onSuccess, onError };
};

export const eInvoiceInvoiceDataAction = (data, onSuccess, onError) => {
  return { type: E_INVOICE_INVOICE_DATA, data, onSuccess, onError };
};

export const eInvoiceTableAction = (data, onSuccess, onError) => {
  return { type: E_INVOICE_TABLE, data, onSuccess, onError };
};

export const eInvoiceGenerateAction = (data, onSuccess, onError) => {
  return { type: E_INVOICE_GENERATE, data, onSuccess, onError };
};
